import AppHeader from '@components/AppNavigation/AppHeader';
import TenantsTable from '@components/Tenants/TenantsTable';
import { Box } from '@mui/system';
import React, { FC } from 'react';

const TenantsPage: FC = () => (
	<Box
		data-testid="tenants-page"
		id="tenants-page"
		display="flex"
		overflow="hidden"
		flexGrow={1}
		flexDirection="column"
	>
		<AppHeader translation="pages.tenants.title" />
		<TenantsTable />
	</Box>
);

export default TenantsPage;
